import React, { useEffect, useState } from "react";
import { notification } from "antd";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate } from "react-router-dom"

import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { faArrowLeft, faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

import { list as getGeneralData, updateGeneralData} from "../../../controllers/V1/generalDataController"
import { getCrunchSettings } from "../../../controllers/V1/hourlyAnalyserController";
import "./hourlyAnalyserResponsive.css";
const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [currentSettingData, setCurrentSettingData] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  /*********************** End ************************ */
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    const { name, value } = e.target;
    if(name ==='analyser_emails'){
      const regex = /^[a-zA-Z0-9_@,.]*$/;
      const cleanValue = value.replace(/\s+/g, "");
      if (regex.test(cleanValue)) {
        setAddEditSata((pre) => ({
          ...pre,
          [name]: cleanValue,
        }));
      }
    } else{
      setAddEditSata((pre) => ({
        ...pre,
        [e.target.name]: e.target.value,
      }));
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

 

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);
        const options ={
          method                  : "settingsedit", 
          productname             : form.get('productname')?.replace(/\//g, '_'), 
          productlength           : form.get('productlength'), 
          minnumber               : form.get('number_range_start'), 
          maxnumber               : form.get('number_range_end'), 
          includezerorows         : 1, 
          
          straight1               : 0,
          straight2               : 0,
          straight3               : 0,
          straight4               : 0,
          straight5               : 0,
          straight6               : 0,
          straight7               : 0,
          straight8               : 0,

          straight1amount         : 0,
          straight2amount         : 0,
          straight3amount         : 0,
          straight4amount         : 0,
          straight5amount         : 0,
          straight6amount         : 0,
          straight7amount         : 0,
          straight8amount         : 0,

          rumble1               : form.get('rumble_prize_1') > 0 ? 1 : 0,
          rumble2               : form.get('rumble_prize_2') > 0 ? 1 : 0,
          rumble3               : form.get('rumble_prize_3') > 0 ? 1 : 0,
          rumble4               : form.get('rumble_prize_4') > 0 ? 1 : 0,
          rumble5               : form.get('rumble_prize_5') > 0 ? 1 : 0,
          rumble6               : form.get('rumble_prize_6') > 0 ? 1 : 0,
          rumble7               : form.get('rumble_prize_7') > 0 ? 1 : 0,
          rumble8               : form.get('rumble_prize_8') > 0 ? 1 : 0,

          rumble1amount         : form.get('rumble_prize_1') || 0,
          rumble2amount         : form.get('rumble_prize_2') || 0,
          rumble3amount         : form.get('rumble_prize_3') || 0,
          rumble4amount         : form.get('rumble_prize_4') || 0,
          rumble5amount         : form.get('rumble_prize_5') || 0,
          rumble6amount         : form.get('rumble_prize_6') || 0,
          rumble7amount         : form.get('rumble_prize_7') || 0,
          rumble8amount         : form.get('rumble_prize_8') || 0,

          reverse1               : 0,
          reverse2               : 0,
          reverse3               : 0,
          reverse4               : 0,
          reverse5               : 0,
          reverse6               : 0,
          reverse7               : 0,
          reverse8               : 0,
          reverse1amount         : 0,
          reverse2amount         : 0,
          reverse3amount         : 0,
          reverse4amount         : 0,
          reverse5amount         : 0,
          reverse6amount         : 0,
          reverse7amount         : 0,
          reverse8amount         : 0,
        }
        // console.log("options : ", options);
        // return false;
        const res = await getCrunchSettings(options);
        console.log("res : ", res);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
      
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchCrunchSettings = async () => {
    try {
      setIsLoading(true);
        const options = {
            method : "settingsview",
            productname : ADDEDITDATA?.title?.replace(/\//g, '_')
        }
        const res = await getCrunchSettings(options);
        if(res.status === true){
            setCurrentSettingData(res?.result?.data);
            console.log("res?.result?.data :", res?.result?.data);
            notification.open({
              message: "Data fetched.",
              description: `${res?.result?.message}`,
              placement: "topRight",
              icon: <FontAwesomeIcon style={{ color: "yellow" }} icon={faInfoCircle} />,
              duration: 2,
            });
        } else{
            notification.open({
                message: "Oops!",
                description: `${res?.message}`,
                placement: "topRight",
                icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
                duration: 2,
              });
        }
    } catch (error) {
      console.log('[error] : ', error);
        setIsLoading(false);
    } finally{
      setIsLoading(false);
    } 
  }

  useEffect(() => {
    fetchCrunchSettings();
    document.title = `U-Winn CRM || General Data`;
  }, []);

  const gameType = Number(ADDEDITDATA?.game_type) || 0;
  const straightFields = Array.from({ length: gameType }, (_, index) => gameType - index);
  const isFieldDifferent = (fieldName) => {
    const addEditValue = (ADDEDITDATA?.[`rumble_prize_${fieldName}`] ?? "").toString().trim();
    const currentValue = (currentSettingData?.[`Rumble ${fieldName} Amount`] ?? "").toString().trim();
    return addEditValue !== currentValue;
  };


  return (
    <div>
      {" "}
      <div className="container-fluid hourly-page-container">
        <div className="Inventory_edit_page_main_div hourly-settings-header">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> Game Settings </h5>
          </React.Fragment>
          <Link to={"/hourly-analyser"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary hourly-back-btn"> <FontAwesomeIcon icon={faArrowLeft}/> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet hourly-settings-form" onSubmit={handleSubmit}>
                <input type="hidden" name="edit_id" id="edit_id" value={ADDEDITDATA?._id}/>
                <div className="row ">
                  <div className="row">
                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_start_time" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Game Name :{" "}
                      </label>
                      <input
                        title="Game Title"
                        type="text"
                        name="productname"
                        className="form-control store_input_field"
                        id="productname"
                        value={ADDEDITDATA?.title}
                        readOnly
                      />
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_end_time" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Game Type :{" "}
                      </label>
                      <input
                        title="Game Type"
                        placeholder="Enter game type."
                        type="text"
                        name="productlength"
                        className="form-control store_input_field"
                        id="productlength"
                        value={ADDEDITDATA?.game_type}
                        readOnly
                      />
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_emails" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Number Range Start :{" "}
                      </label>
                      <input
                        title="Number Range Start"
                        placeholder="Enter number range start."
                        type="text"
                        name="number_range_start"
                        className="form-control store_input_field"
                        id="number_range_start"
                        value={ADDEDITDATA?.number_range_start}
                        readOnly
                      />                      
                    </div>

                    <div className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label htmlFor="analyser_emails" className="all_section_for_label_main_class" >
                        <span style={{ color: "red" }}>*</span>Number Range End :{" "}
                      </label>
                      <input
                        title="Number Range End"
                        placeholder="Enter number range end."
                        type="text"
                        name="number_range_end"
                        className="form-control store_input_field"
                        id="number_range_end"
                        value={ADDEDITDATA?.number_range_end}
                        readOnly
                      />                      
                    </div>

                    {/* Straight */}
                    {/* {straightFields.map((matchNumber) => {
                      const fieldName = `straight_prize_${matchNumber}`;
                      const showWarning = isFieldDifferent(fieldName);
                      return (
                        <div key={fieldName} className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label htmlFor={fieldName} className="all_section_for_label_main_class" >
                            <span style={{ color: "red" }}>*</span>Straight Match {matchNumber} :{" "}
                          </label>
                          <input
                            title="Invoice End Time."
                            placeholder="Enter invoice end time."
                            type="text"
                            name={fieldName}
                            className="form-control store_input_field"
                            id={fieldName}
                            value={ADDEDITDATA?.[fieldName] ?? ""}
                            onChange={handleChange}
                          />
                          {showWarning && (
                            <small className="text-warning">
                              Warning: value is different from current setting.
                            </small>
                          )}
                        </div>
                      );
                    })} */}
                    {/* Rumble */}
                    {straightFields.map((matchNumber) => {
                      const fieldName = `rumble_prize_${matchNumber}`;
                      const showWarning = isFieldDifferent(matchNumber);
                      return (
                        <div key={fieldName} className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label htmlFor={fieldName} className="all_section_for_label_main_class" >
                            <span style={{ color: "red" }}>*</span>Rumble Match {matchNumber} :{" "}
                          </label>
                          <input
                            title="Rumble Match."
                            placeholder="Enter rumble match."
                            type="text"
                            name={fieldName}
                            className="form-control store_input_field"
                            id={fieldName}
                            value={ADDEDITDATA?.[fieldName] ?? ""}
                            onChange={handleChange}
                          />
                          {showWarning && (
                            <small className="text-warning">
                              Warning: value is different from current setting.
                            </small>
                          )}
                        </div>
                      );
                    })}

                    {/* Chance */}
                    {/* {straightFields.map((matchNumber) => {
                      const fieldName = `chance_prize_${matchNumber}`;
                      const showWarning = isFieldDifferent(fieldName);
                      return (
                        <div key={fieldName} className="form-group col-lg-3 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label htmlFor={fieldName} className="all_section_for_label_main_class" >
                            <span style={{ color: "red" }}>*</span>Chance Match {matchNumber} :{" "}
                          </label>
                          <input
                            title="Chance Match."
                            placeholder="Enter chance match."
                            type="text"
                            name={fieldName}
                            className="form-control store_input_field"
                            id={fieldName}
                            value={ADDEDITDATA?.[fieldName] ?? ""}
                            onChange={handleChange}
                          />
                          {showWarning && (
                            <small className="text-warning">
                              Warning: value is different from current setting.
                            </small>
                          )}
                        </div>
                      );
                    })}                   */}

                  </div>
                  
                </div>  
                <div className="inventory_edit_submit_btn hourly-submit-wrap">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Update </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default Settings;
